import React from 'react';
import gif from '../../assets/images/FINGER_print.gif';


function CaptureFingerprint({aepsStatus,fingerprintLoader,Capture,payload}) {

    return(
		<div className="tab-content-left">
					<h2>
						{aepsStatus === 'verifyCustomer'
							? 'VERIFY CUSTOMER FINGERPRINT'
							: aepsStatus === 'retailerLogin'
							?'VERIFY RETAILER FINGERPRINT FOR LOGIN'
							: aepsStatus === 'verifyCustomerForTransaction'
							? 'VERIFY RETAILER FINGERPRINT FOR WITHDRAWAL'
							: 'VERIFY FINGERPRINT FOR ENABLE'}
					</h2>

					<img style={{ height: '135px', display: 'block', margin: '60px auto' }} className="mt20" src={gif}></img>
					{!fingerprintLoader && (
						<>
						
							{aepsStatus === 'verifyFingerPrint'? (
								<button type="submit" className="button-outline" onClick={() => Capture({}, 'verify')}>
									FINGER PRINT VERIFY
								</button>
							):""}
							{aepsStatus === 'verifyCustomer' ? (
								<button type="submit" className="button-outline" onClick={() => Capture(payload, 'customer')}>
									FINGER PRINT VERIFY
								</button>
							):""}
							{(aepsStatus === 'retailerLogin') || (aepsStatus === 'verifyCustomerForTransaction')?
								<button type="submit" className="button-outline" onClick={() => Capture({}, 'login')}>
									FINGER PRINT VERIFY
								</button>:""
							}
						</>
					)}
				</div>
	)
}

export default CaptureFingerprint